// @noflow
import { getRandomId } from './utils';

const initialState = {
  airings: [],
  airingsMap: {},
  changeReceiverError: false,
  changeReceiverFetching: false,
  channel: undefined,
  channelInfo: undefined,
  connectionMode: undefined,
  containerOpen: false,
  contentId: undefined,
  debugVisible: false,
  dvrId: undefined,
  dvrListing: undefined,
  dvrProgress: undefined,
  playerLastActive: undefined,
  error: false,
  fetching: false,
  listing: {},
  metadata: {},
  customAttributesMap: {},
  miniPlayer: false,
  recentVideoId: null,
  recentlyWatchedProgress: null,
  nextQvtPayload: {},
  playbackCouldNotBeStarted: false,
  postToRecentsError: {},
  programInfo: null,
  playerType: undefined,
  playerVisible: false,
  playerErrorCode: undefined,
  playerErrorResponseText: undefined,
  playerErrorResponseCode: undefined,
  playerErrorType: undefined,
  playerErrorName: undefined,
  playerErrorServerResponse: undefined,
  putToRecentsError: {},
  putToRecentsFinished: false,
  isNativePlayerInFullscreen: false,
  qvtPayload: {},
  qvtDate: undefined,
  resumePlayback: false,
  isSeeking: false,
  slingPlaybackInfo: {},
  slingPlayerConnected: false,
  slingPlayerError: false,
  slingPlayerErrorReason: undefined,
  slingPlayerErrorMessage: undefined,
  slingPlayerErrorType: undefined,
  slingPlayerErrorCode: undefined,
  slingPlayerErrorObject: undefined,
  slingPlayerEventObject: undefined,
  slingPlayerLoading: false,
  slingPlayerPlaying: false,
  slingPlayerLocalStorage: {},
  slingProgress: null,
  slingErrors: {
    errors: {
      2050: [],
      2052: [],
      2014: [],
      2009: [],
      2025: [],
      2040: [],
      2008: [],
      all: [],
    },
  },
  slingSessionActive: false,
  sourceType: undefined,
  stream: undefined,
  asyncPopupInfo: undefined,
  tunersPopupInfo: undefined,
  unsupportedReceiverModalOpen: false,
  unsupportedReceiverReason: '',
  playerStreamId: undefined,
  bingeWatching: {
    isBingeWatchingCanceled: false,
    messageData: undefined,
    isNextBingeEpisodeLoading: false,
  },
  playerEventObject: undefined,
  recentsProgress: {
    isRequestInProgress: false,
    progress: 0,
  },
  isAdPlaying: false,
  playerPageOpened: false,
  debugModeEnabled: false,
  customAttributes: {},
  closedCaptions: {
    enabled: false,
    foregroundColor: null,
    backgroundColor: null,
    edgeType: null,
    edgeColor: null,
    windowColor: null,
    foregroundOpacity: null,
    fontSize: null,
    backgroundOpacity: null,
    windowOpacity: null,
    fontFamily: null,
  },
  bufferLevel: 0,
};

const putCustomAttributes = (customAttributesMap, ottMappingId, customAttributes) => {
  customAttributesMap[ottMappingId] = customAttributes;
  return customAttributesMap;
};

const putAirings = (airingsMap, ottMappingId, airings) => {
  airingsMap[ottMappingId] = airings;
  return airingsMap;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'NATIVE_PLAYER_IS_FULLSCREEN':
      return {
        ...state,
        isNativePlayerInFullscreen: true,
      };
    case 'NATIVE_PLAYER_IS_COLLAPSED':
      return {
        ...state,
        isNativePlayerInFullscreen: false,
      };
    case 'REQUEST_LIVE_VIDEO_METADATA':
      return {
        ...state,
        fetching: true,
        error: false,
      };
    case 'RECEIVE_LIVE_VIDEO_METADATA': {
      const { payload, ottMappingId } = action;
      return {
        ...state,
        fetching: false,
        error: false,
        metadata: {
          custom_attributes: payload,
        },
        customAttributesMap: putCustomAttributes(state.customAttributesMap, ottMappingId, payload),
      };
    }
    case 'REQUEST_LIVE_VIDEO_METADATA_ERROR': {
      const { payload: error } = action;
      return {
        ...state,
        fetching: false,
        error: error.error,
      };
    }
    case 'REQUEST_VIDEO_METADATA':
      return {
        ...state,
        fetching: true,
        error: false,
      };
    case 'RECEIVE_VIDEO_METADATA': {
      const { payload } = action;
      return {
        ...state,
        fetching: false,
        error: false,
        metadata: payload,
      };
    }
    case 'REQUEST_VIDEO_METADATA_ERROR': {
      const { payload: error } = action;
      return {
        ...state,
        fetching: false,
        error: error?.error,
      };
    }
    case 'REQUEST_QVT': {
      return { ...state, qvtPayload: { ...state.qvtPayload, fetching: true } };
    }
    case 'RECEIVE_QVT': {
      const {
        payload: { response, headers },
      } = action;
      return {
        ...state,
        qvtPayload: response,
        qvtDate: headers?.get('Date'),
      };
    }
    case 'REQUEST_NEXT_QVT': {
      return { ...state, nextQvtPayload: { ...state.nextQvtPayload, fetching: true } };
    }
    case 'RECEIVE_NEXT_QVT': {
      const {
        payload: { response, headers },
      } = action;
      return {
        ...state,
        nextQvtPayload: response,
      };
    }
    case 'LL_EVENT_TRANSITION': {
      return {
        ...state,
        qvtPayload: state.nextQvtPayload,
        nextQvtPayload: {},
      };
    }
    case 'REQUEST_AIRINGS_DATA': {
      return {
        ...state,
        fetching: true,
        error: false,
      };
    }
    case 'RECEIVE_AIRINGS_DATA': {
      const { payload, ottMappingId } = action;
      const { airings } = payload;
      return {
        ...state,
        fetching: false,
        error: false,
        airingsMap: putAirings(state.airingsMap, ottMappingId, airings),
      };
    }
    case 'REQUEST_AIRINGS_DATA_ERROR': {
      const { payload: error } = action;
      return {
        ...state,
        fetching: false,
        error: error.error,
      };
    }
    case 'SET_PLAYER_STREAM': {
      const {
        stream,
        playerVisible,
        playerType,
        sourceType,
        contentId,
        listing,
        channelInformation,
        analyticsData,
      } = action;
      return {
        ...state,
        stream,
        streamLoaded: false,
        playerVisible,
        miniPlayer: false,
        playerType,
        sourceType,
        playbackCouldNotBeStarted: false,
        contentId,
        listing,
        channelInfo: channelInformation,
        playerStreamId: playerType === 'sling' ? getRandomId() : undefined,
        analyticsData,
      };
    }
    case 'PLAYER_STREAM_LOADED': {
      return {
        ...state,
        streamLoaded: true,
        playbackCouldNotBeStarted: false,
      };
    }
    case 'SET_DVR_STREAM': {
      const {
        dvrId,
        dvrProgress,
        dvrListing,
        playerVisible,
        playerType,
        sourceType,
        contentId,
        resumePlayback,
      } = action;
      return {
        ...state,
        dvrId,
        dvrProgress,
        dvrListing,
        stream: undefined,
        channel: undefined,
        playerVisible,
        playerType,
        sourceType,
        miniPlayer: false,
        slingPlayerPlaying: true,
        contentId,
        resumePlayback: resumePlayback != null ? resumePlayback : state.resumePlayback,
      };
    }
    case 'SET_LIVE_STREAM': {
      const { channel, listing, playerVisible, playerType, sourceType } = action;
      return {
        ...state,
        channel,
        stream: listing,
        dvrId: undefined,
        playerVisible,
        playerType,
        sourceType,
        miniPlayer: false,
      };
    }
    case 'SET_SLING_PLAYBACK_INFO': {
      const { isSeeking, slingPlaybackInfo } = action;
      const { contentType } = slingPlaybackInfo;
      return {
        ...state,
        isSeeking,
        slingPlaybackInfo,
        sourceType:
          contentType === 'liveTip' ||
          contentType === 'liveDelayed' ||
          contentType === 'live' ||
          contentType === 'liveRec' ||
          contentType === 'liveDelayedRec'
            ? 'live'
            : 'dvr',
      };
    }
    case 'RESET_DVR_STATUS': {
      return {
        ...state,
        dvrId: undefined,
        dvrProgress: undefined,
      };
    }
    case 'TOGGLE_PLAYER_CONTAINER': {
      const { containerOpen } = action;
      return {
        ...state,
        containerOpen,
      };
    }
    case 'TOGGLE_UNSUPPORTED_RECEIVER_MODAL': {
      const { modalOpen, reason } = action;
      return {
        ...state,
        unsupportedReceiverModalOpen: modalOpen,
        unsupportedReceiverReason: reason,
      };
    }
    case 'TOGGLE_PLAYER_VISIBILITY': {
      const { playerVisible } = action;
      return {
        ...state,
        playerVisible,
        miniPlayer: false,
      };
    }
    case 'UNDOCK_MINI_PLAYER': {
      return {
        ...state,
        miniPlayer: true,
      };
    }
    case 'DOCK_MINI_PLAYER': {
      return {
        ...state,
        miniPlayer: false,
      };
    }

    case 'PLAYBACK_COULD_NOT_BE_STARTED': {
      return {
        ...state,
        playbackCouldNotBeStarted: action.playbackCouldNotBeStarted,
      };
    }

    case 'POST_TO_RECENTS': {
      return {
        ...state,
        recentVideoId: action.payload?.id,
        putToRecentsFinished: false,
        putToRecentsError: {},
      };
    }

    case 'POST_TO_RECENTS_ERROR': {
      return {
        ...state,
        postToRecentsError: action.payload,
      };
    }

    case 'PUT_TO_RECENTS': {
      return state;
    }

    case 'PUT_TO_RECENTS_ERROR': {
      return {
        ...state,
        putToRecentsError: action.payload,
      };
    }

    case 'PUT_TO_RECENTS_FINISHED': {
      return {
        ...state,
        putToRecentsFinished: true,
      };
    }

    case 'CHANGE_ACTIVE_RECEIVER': {
      return {
        ...state,
        changeReceiverError: false,
        changeReceiverFetching: true,
      };
    }

    case 'CHANGE_ACTIVE_RECEIVER_SUCCESS': {
      return {
        ...state,
        changeReceiverError: false,
        changeReceiverFetching: false,
      };
    }

    case 'CHANGE_ACTIVE_RECEIVER_ERROR': {
      return {
        ...state,
        changeReceiverError: true,
      };
    }

    case 'SET_PLAYER_PROGRAM_INFO': {
      const { programInfo, contentType } = action;
      return {
        ...state,
        programInfo,
        sourceType:
          contentType !== '' &&
          (contentType === 'liveTip' ||
            contentType === 'liveDelayed' ||
            contentType === 'live' ||
            contentType === 'liveRec' ||
            contentType === 'liveDelayedRec')
            ? 'live'
            : 'dvr',
      };
    }

    case 'SLING_PLAYER_CONNECT': {
      return {
        ...state,
        slingPlayerConnected: true,
        slingPlayerLoading: false,
      };
    }

    case 'SLING_PLAYER_PLAY': {
      return {
        ...state,
        slingPlayerConnected: true,
        slingPlayerPlaying: true,
        slingPlayerError: false,
        slingPlayerErrorReason: undefined,
        slingPlayerErrorType: undefined,
        slingPlayerErrorCode: undefined,
        slingPlayerErrorObject: undefined,
      };
    }

    case 'SLING_PLAYER_STOP': {
      return {
        ...state,
        slingPlayerPlaying: false,
        slingProgress: Date.now(),
      };
    }

    case 'SLING_PLAYER_UNLOAD': {
      return {
        ...state,
        slingPlayerPlaying: false,
        slingProgress: Date.now(),
      };
    }

    case 'SLING_PLAYER_ERROR': {
      return {
        ...state,
        slingPlayerPlaying: false,
        slingPlayerError: !!action.errorReason,
        slingPlayerLoading: false,
        slingPlayerErrorReason: action.errorReason,
        slingPlayerErrorMessage: action.errorMessage,
        slingPlayerErrorType: action.errorType,
        slingPlayerErrorCode: action.errorCode,
        slingPlayerErrorObject: action.error,
        asyncPopupInfo: undefined,
      };
    }

    case 'SET_SLING_PLAYER_LOADING': {
      return {
        ...state,
        slingPlayerLoading: !!action.loading,
        slingPlayerStatus: action.status || undefined,
      };
    }

    case 'SET_SLING_PLAYER_STATUS': {
      return {
        ...state,
        slingPlayerStatus: action.status || undefined,
      };
    }

    case 'SET_SLING_PLAYER_CONNECTION_MODE': {
      const { mode } = action;
      return {
        ...state,
        connectionMode: mode,
      };
    }

    case 'RESET_PLAYER': {
      const { playerVisible } = action;

      return {
        ...initialState,
        playerVisible: playerVisible !== undefined ? playerVisible : state.playerVisible,
        slingProgress: state.slingProgress,
        slingLocalStorage: state.slingLocalStorage,
        debugModeEnabled: state.debugModeEnabled,
      };
    }

    case 'TOGGLE_DEBUG_INFO': {
      const { debugVisible } = action;
      return {
        ...state,
        debugVisible,
      };
    }

    case 'DISMISS_ASYNC_POPUP': {
      return {
        ...state,
        asyncPopupInfo: undefined,
      };
    }

    case 'SHOW_ASYNC_POPUP': {
      return {
        ...state,
        asyncPopupInfo: action.data,
      };
    }

    case 'DISMISS_TUNERS_POPUP': {
      return {
        ...state,
        tunersPopupInfo: undefined,
      };
    }

    case 'SHOW_TUNERS_POPUP': {
      return {
        ...state,
        tunersPopupInfo: action.data,
      };
    }

    case 'SWITCH_PLAYER_DATA': {
      const { ottMappingId } = action;
      return {
        ...state,
        airings: state.airingsMap[ottMappingId] || [],
        metadata: {
          custom_attributes: state.customAttributesMap[ottMappingId] || {},
        },
      };
    }

    case 'PLAYER_ERROR': {
      const { code, responseCode, name, errorType, responseText, serverResponse } = action;
      return {
        ...state,
        playerErrorCode: code,
        playerErrorResponseText: responseText,
        playerErrorResponseCode: responseCode,
        playerErrorType: errorType,
        playerErrorName: name,
        playerErrorServerResponse: serverResponse,
      };
    }

    case 'RECEIVE_SET_CURRENT_PROFILE_ID':
      return {
        ...initialState,
        slingLocalStorage: state.slingLocalStorage,
        debugModeEnabled: state.debugModeEnabled,
      };

    case '@@found/RESOLVE_MATCH': {
      if (state.playerVisible && action.payload?.location?.pathname !== '/live_tv') {
        return {
          ...state,
          miniPlayer: true,
        };
      }
      return state;
    }
    case 'RESET_PLAYER_STREAM': {
      return { ...state, stream: undefined, programInfo: null };
    }
    case 'START_PLAYBACK_IN_PROGRESS': {
      return { ...state, resumePlayback: true };
    }
    case 'START_PLAYBACK_FROM_BEGINNING': {
      return { ...state, resumePlayback: false };
    }
    case 'SHOW_BINGE_MESSAGE': {
      const { timeLeft, nextEpisode } = action;
      return {
        ...state,
        bingeWatching: {
          ...state.bingeWatching,
          messageData: { timeLeft, nextEpisode },
        },
      };
    }
    case 'CANCEL_NEXT_BINGE_EPISODE': {
      const { clearData } = action;

      return {
        ...state,
        bingeWatching: {
          ...state.bingeWatching,
          isBingeWatchingCanceled: clearData ? state.bingeWatching.isBingeWatchingCanceled : true,
          messageData: clearData ? undefined : state.bingeWatching.messageData,
        },
      };
    }
    case 'IS_NEXT_BINGE_EPISODE_LOADING': {
      const { isNextBingeEpisodeLoading } = action;

      return {
        ...state,
        metadata: isNextBingeEpisodeLoading ? {} : state.metadata,
        bingeWatching: {
          ...state.bingeWatching,
          isBingeWatchingCanceled: false,
          isNextBingeEpisodeLoading,
        },
      };
    }

    case 'SET_SLING_ERRORS_OBJECT': {
      const { errorCode, slingError } = action;
      const { slingErrors } = state;
      const { errors } = slingErrors;
      if (!initialState.slingErrors.errors[errorCode]) {
        return state;
      }
      return {
        ...state,
        slingErrors: {
          errors:
            slingError && errorCode
              ? {
                  ...errors,
                  [errorCode]: [...(errors[errorCode] || []), slingError],
                  all: [...(errors.all || []), slingError],
                }
              : { ...errors },
        },
      };
    }

    case 'RESET_SLING_ERRORS_OBJECT': {
      return {
        ...state,
        slingErrors: initialState.slingErrors,
      };
    }

    case 'SET_SLING_PLAYER_EVENT_OBJECT': {
      const { data } = action;
      return {
        ...state,
        slingPlayerEventObject: data,
      };
    }

    case 'SET_PLAYER_EVENT_OBJECT': {
      const { data } = action;
      return {
        ...state,
        playerEventObject: data,
      };
    }

    case 'SET_PLAYER_SESSION_ACTIVE': {
      const { isActive } = action;
      return {
        ...state,
        slingSessionActive: isActive,
      };
    }

    case 'REQUEST_RECENTS_PROGRESS': {
      return {
        ...state,
        recentsProgress: {
          isRequestInProgress: true,
          progress: 0,
        },
      };
    }
    case 'RECEIVE_RECENTS_PROGRESS': {
      const { progress } = action;

      return {
        ...state,
        recentsProgress: {
          isRequestInProgress: false,
          progress,
        },
      };
    }
    case 'SET_SLING_PLAYER_LOCAL_STORAGE_ITEM': {
      const { key, value } = action;
      return {
        ...state,
        slingPlayerLocalStorage: {
          ...state.slingPlayerLocalStorage,
          [key]: value,
        },
      };
    }
    case 'REMOVE_SLING_PLAYER_LOCAL_STORAGE_ITEM': {
      const { key } = action;
      return {
        ...state,
        slingPlayerLocalStorage: {
          ...state.slingPlayerLocalStorage,
          [key]: undefined,
        },
      };
    }
    case 'CLEAR_SLING_PLAYER_LOCAL_STORAGE': {
      return {
        ...state,
        slingPlayerLocalStorage: {},
      };
    }

    case 'IS_AD_PLAYING': {
      const { isAdPlaying } = action;
      return {
        ...state,
        isAdPlaying,
      };
    }

    case 'SET_PLAYER_LAST_ACTIVE': {
      const { playerLastActive } = action;
      return {
        ...state,
        playerLastActive,
      };
    }
    case 'SET_PLAYER_PAGE_OPENED': {
      const { playerPageOpened } = action;
      return {
        ...state,
        playerPageOpened,
      };
    }
    case 'SET_DEBUG_MODE_ENABLED': {
      const { enabled } = action;
      return {
        ...state,
        debugModeEnabled: enabled,
      };
    }
    case 'RECEIVE_PLAYER_ATTRIBUTES': {
      const { customAttributes } = action;
      return {
        ...state,
        customAttributes,
      };
    }
    case 'SET_CLOSED_CAPTIONS_SETTINGS': {
      const { settings } = action;
      return {
        ...state,
        closedCaptions: settings,
      };
    }
    case 'SET_CLOSED_CAPTIONS_ENABLED': {
      const { enabled } = action;
      return {
        ...state,
        closedCaptions: { ...state.closedCaptions, enabled },
      };
    }

    case 'SET_BUFFER_LEVEL': {
      const { bufferLevel } = action;
      return {
        ...state,
        bufferLevel,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
